<dx-popup
  [visible]="isPopupVisible"
  [showTitle]="false"
  [width]="480"
  height="auto"
  (onHiding)="closePopup()"
>
  <!-- [hideOnOutsideClick]="true" -->
  <div *dxTemplate="let data of 'content'" class="popup-container">
    <!-- Header: Dynamic Title based on Mode -->
    <div class="popup-header">
      <h5 class="popup-title">
        {{
          mode === "add"
            ? "Add Holiday Event/Reason"
            : "Edit Holiday Event/Reason"
        }}
      </h5>
      <button class="close-btn" (click)="closePopup()">
        <i class="dx-icon-close"></i>
      </button>
    </div>

    <p class="popup-description">
      New events/reasons become immediately available in the dropdown across all
      future Holiday Calendar years.
    </p>

    <div class="form-group">
      <label class="form-label">Event/Reason Name</label>
      <dx-text-box
        [(value)]="eventName"
        placeholder="e.g., Pohela Boishakh"
       
      >
        <dx-validator validationGroup="validationGrp">
          <dxi-validation-rule
            type="required"
            message="Event/Reason name is required"
          >
          </dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>

    <div class="popup-actions">
      <dx-button
        text="Cancel"
        class="themeButtonWhite"
        (onClick)="closePopup()"
      >
      </dx-button>

      <dx-button
        [text]="mode === 'add' ? 'Save Event/Reason' : 'Update Event/Reason'"
        class="themeButton"
        (onClick)="saveEvent()"
      >
      </dx-button>
    </div>
  </div>
</dx-popup>
